import type {WeekdayLabels} from './types';

const WEEKDAY_BASE_SUNDAY = new Date(2024, 0, 7);

const getWeekdayLabelsByDayIndex = (languageCode: string): WeekdayLabels => {
    return Array.from({length: 7}, (_, dayIndex) => {
        const date = new Date(WEEKDAY_BASE_SUNDAY);

        date.setDate(WEEKDAY_BASE_SUNDAY.getDate() + dayIndex);
        return date.toLocaleDateString(languageCode, {weekday: 'narrow'});
    }) as WeekdayLabels;
};

const formatMonthYearLabel = (date: Date, languageCode: string): string => {
    const month = date.toLocaleDateString(languageCode, {month: 'long'});
    const year = date.getFullYear();

    return `${month} ${year}`;
};

export {formatMonthYearLabel, getWeekdayLabelsByDayIndex};
